import { RenderRailCardProps, RenderRailSearchErrorCardProps } from "entities/shared/railCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { RailSearchCardModel } from "../model/model";

type RailSearchCardProps = {
  data: RailSearchCardModel;
  shipmentType: ValueOf<typeof ShipmentType>;
  className?: string;
  openCard: (data: RailSearchCardModel) => void;
  deleteCardHandler: (card: RailSearchCardModel) => void;
  renderCard: (props: RenderRailCardProps) => JSX.Element;
  renderErrorCard: (props: RenderRailSearchErrorCardProps) => JSX.Element;
};

export const RailSearchCard: RFC<RailSearchCardProps> = ({
  data,
  shipmentType,
  openCard,
  deleteCardHandler,
  renderCard,
  renderErrorCard,
}) => {
  const onDeleteHandler = () => deleteCardHandler(data);

  const onOpenHandler = () => {
    openCard(data);
  };

  // TODO: Add error text
  const errorText = "";

  if (errorText) {
    return renderErrorCard({
      text: errorText,
      status: "error",
      reference: data.reference,
      onDelete: onDeleteHandler,
    });
  }

  return renderCard({
    shipmentType,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    count: data.equipmentsCount,
    reference: data.reference,
    status: data.status,
    directionFrom: data.from,
    directionTo: data.to,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
  });
};
